export const GET_AGENT = 'GET_AGENT';
export const GET_AGENT_SUCCESS = 'GET_AGENT_SUCCESS';
export const GET_AGENT_FAIL = 'GET_AGENT_FAIL';
